import { WebStorageStateStore } from "oidc-client";
import { USER_MANAGER_INIT } from "../actions/userManager";
import { createUserManager } from "redux-oidc";
var initialState = null;
var userManagerReducer = function (state, _a) {
    if (state === void 0) { state = initialState; }
    var type = _a.type, payload = _a.payload;
    if (type === USER_MANAGER_INIT && payload) {
        var authority = payload.authority, client_id = payload.client_id;
        var userManagerConfig = {
            authority: authority,
            client_id: client_id,
            response_type: 'code',
            scope: 'openid profile email PunchCard directory id offline_access',
            redirect_uri: origin + "/oauth.html",
            silent_redirect_uri: origin + "/silent-refresh.html",
            post_logout_redirect_uri: origin,
            automaticSilentRenew: true,
            filterProtocolClaims: true,
            loadUserInfo: true,
            userStore: new WebStorageStateStore({ store: window.localStorage })
        };
        var userManager_1 = createUserManager(userManagerConfig);
        setInterval(function () {
            userManager_1.querySessionStatus().catch();
        }, 900000);
        return userManager_1;
    }
    else {
        return state;
    }
};
export default userManagerReducer;
